const passkey_sign_in = {
    setup_page: {
        title: 'ورود خود را ساده‌تر کنید',
        subtitle: 'یک کلید عبور ایجاد کنید',
        description: 'کلید عبور خود را با استفاده از ویژگی‌های زیستی دستگاه، کلیدهای امنیتی مانند YubiKey یا سایر روش‌های موجود ثبت کنید.',
    },
    trigger_conditional_ui_failed: 'فعال‌سازی تکمیل خودکار کلید عبور ناموفق بود.',
};
export default Object.freeze(passkey_sign_in);
